<template>
  <v-dialog v-model="dialog" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">Настройка прав доступа</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout wrap>
            <dantser-scope
                    :treedata="treedata"
                    withScopes
                    v-model="scopes"
            ></dantser-scope>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="kanban-btn-cancel" @click="dialog = false">Закрыть</v-btn>
        <v-btn class="kanban-btn-ok" @click="ok()">Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import DantserScope from '@/components/DantserScope'
  import apiAccess from '@/apps/bpm/kanban/api/access/api.js'

  /**
   *
   *
   */
  const CONTAINER = 10;

  /**
   *
   *
   */
  const POST = 20;



  /**
   *
   *
   */
  export default {

    name: 'ScopeDialog',

    componentName: "ScopeDialog",

    /**
     * Подключенные компоненты.
     *
     */
    components: {
      DantserScope
    },

    /**
     *
     *
     */
    props: {

      board: {
        type: Object,
        required: true
      }
    },

    /**
     *
     *
     */
    mounted() {

    },

    /**
     *
     *
     */
    data() {

      return {

        dialog: false,

        treedata: [],

        scopes: []
      }
    },

    /**
     *
     *
     */
    watch: {

      editBoard: {

        handler( editBoard ) {

        },

        immediate: true
      }
    },

    /**
     *
     *
     */
    computed: {

    },

    /**
     *
     *
     */
    methods: {

      /**
       *
       *
       */
      show() {

        this.scopes = []

        this.getTrees()

        this.getAccesses()

        this.dialog = true
      },

      /**
       *
       *
       */
      hide() {

        this.dialog = false
      },

      /**
       *
       *
       */
      ok() {

        this.dialog = false

        this.$emit( 'ok', this.board, this.scopes )

        return apiAccess.setAccess( this.board.id, this.toFormat( this.scopes ) )
          .then( ( data ) => {

          } )
          .catch( ( error ) => {
            console.error( error )
          } )
      },

      /**
       *
       *
       */
      getTrees() {

        this.$store.dispatch( 'app/org/tree', 'other' ).then( usersTree => {
          this.treedata = usersTree
        } )
      },

      /**
       *
       *
       */
      getAccesses() {

        return apiAccess.getAccess( this.board.id )
          .then( ( data ) => {
            this.scopes = this.fromFormat( data.list )
          } )
          .catch( ( error ) => {
            console.error( error )
          } )
      },

      /**
       *
       *
       * @param scopes
       * @returns {*}
       */
      toFormat( scopes ) {

        return scopes.map( ( scope, index ) => {

          let access = {
            entity_type: scope.element_type === 'container' ? CONTAINER : POST,
            entity_id: scope.element_id,
            scope_type: scope.scope_type,
            can_edit: scope.can_edit,
            name: scope.name
          }

          if ( scope.id ) {
            access.id = scope.id
          }

          return access
        } )
      },

      /**
       *
       *
       * @param accesses
       * @returns {*}
       */
      fromFormat( accesses ) {

        return accesses.map( ( access, index ) => {

          let scope = {
            element_type: access.entity_type === CONTAINER ? 'container' : 'post',
            element_id: access.entity_id,
            scope_type: access.scope_type,
            can_edit: access.can_edit,
            name: access.name
          }

          if ( access.id ) {
            scope.id = access.id
          }

          return scope
        } )
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/apps/bpm/kanban/components/ScopeDialog.vue